import React from "react";
import { Dropdown, Menu, Modal } from "antd";
import less from "./tripStatus.module.scss";

// Order and labels as in the Tracer Figma (FM/LM trips, status dropdown)
const STATUSES = [
  { value: "COMPLETED", label: "Completed", dot: less.completed },
  { value: "ONTRIP", label: "On Trip", dot: less.onTrip },
  { value: "ACTIVE", label: "Active", dot: less.active },
  { value: "INACTIVE", label: "Inactive", dot: less.inactive }
];
const STARTED_STATUSES = ["ONTRIP", "COMPLETED"];

const StatusLabel = ({ status }) => {
  const option = STATUSES.find(item => item.value === status);
  return (
    <div className={less.statusLabel}>
      <div className={`${less.dot} ${option ? option.dot : less.inactive}`} />
      <span>{option ? option.label : status}</span>
    </div>
  );
};

// Trip status on a First Mile / Last Mile row. Editable only for
// last_mile_admin; a trip that has started can't go back to INACTIVE.
const TripStatusSelect = ({ status, canEdit, onChange }) => {
  if (!canEdit) return <StatusLabel status={status} />;

  const onSelect = ({ key }) => {
    if (key === status) return;
    const option = STATUSES.find(item => item.value === key);
    Modal.confirm({
      title: `Mark this trip ${option.label}?`,
      okText: "Yes",
      cancelText: "No",
      onOk: () => onChange(key)
    });
  };

  const menu = (
    <Menu onClick={onSelect} selectedKeys={[status]}>
      {STATUSES.map(option => (
        <Menu.Item
          key={option.value}
          disabled={
            option.value === "INACTIVE" && STARTED_STATUSES.includes(status)
          }
        >
          <StatusLabel status={option.value} />
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <Dropdown overlay={menu} trigger={["click"]}>
      <div className={less.trigger}>
        <StatusLabel status={status} />
        <img
          src="https://d1flzashw70bti.cloudfront.net/original/images/bookingdown.svg"
          alt="change status"
        />
      </div>
    </Dropdown>
  );
};

export default TripStatusSelect;
